document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/pages/contact')) return;

  const params = new URLSearchParams(window.location.search);
  const product = params.get('product');
  const enquiry = params.get('enquiry');
  const message = document.querySelector('#ContactForm-body');
  const productField = document.querySelector('#ContactForm-product');
  const productWrapper = document.querySelector('.thf-product-reference');
  const enquiryType = document.querySelector('#ContactForm-enquiry-type');

  if (enquiryType && enquiry) {
    const match = [...enquiryType.options].find((option) => option.value.toLowerCase() === enquiry.toLowerCase());
    if (match) enquiryType.value = match.value;
  }

  if (!product) return;
  if (productField) productField.value = product;
  if (productWrapper) productWrapper.hidden = false;
  if (enquiryType && !enquiry) enquiryType.value = 'Product enquiry';
  if (!message || message.value.trim()) return;

  message.value = `I would like to enquire about ${product}.\n\n`;
  message.dispatchEvent(new Event('input', { bubbles: true }));
});
